import axios from "../services/api/api";

export const FETCH_ORIENTATIONS_BEGIN = "FETCH_ORIENTATIONS_BEGIN";
export const FETCH_ORIENTATIONS_FULFILLED = "FETCH_ORIENTATIONS_FULFILLED";
export const FETCH_ORIENTATIONS_REJECTED = "FETCH_ORIENTATIONS_REJECTED";

export function fetchOrientations(schoolId) {
  return dispatch => {
    dispatch({
      type: FETCH_ORIENTATIONS_BEGIN,
      payload: { loading: true }
    });
    return new Promise((resolve, reject) => {
      if (localStorage.getItem("email")) {
        axios
          .get(`/orientation/getBySchoolId/${schoolId}`)
          .then(response => {
            dispatch({
              type: FETCH_ORIENTATIONS_FULFILLED,
              payload: response.data.result
            });
            resolve(true);
          })
          .catch(err => {
            dispatch({ type: FETCH_ORIENTATIONS_REJECTED, payload: err });
            reject(err);
          });
      }
    });
  };
}
